import { supabase } from '@/core/database/supabase';
import type { AgroProductListData, AgroProductFilters, AgroProductStats } from '../types/agroProductList.types';

export const agroProductListService = {
  async getAgroProductList(companyId: string, filters: AgroProductFilters): Promise<AgroProductListData> {
    let query = supabase
      .from('agro_assets')
      .select(`
        *,
        group:agro_groups(id, name)
      `, { count: 'exact' })
      .eq('company_id', companyId);

    if (filters.search) {
      query = query.or(`name.ilike.%${filters.search}%,code.ilike.%${filters.search}%`);
    }

    if (filters.status && filters.status !== 'all') {
      query = query.eq('status_code', filters.status);
    }

    if (filters.groupId) {
      query = query.eq('group_id', filters.groupId);
    }

    const { data, count, error } = await query.order('created_at', { ascending: false });

    if (error) throw error;

    const items = (data || []).map(item => ({
      ...item,
      group_name: (item.group as any)?.name,
    }));

    const stats: AgroProductStats = {
      totalAssets: count || 0,
      availableCount: items.filter(i => i.status_code === 'active').length,
      outOfStockCount: items.filter(i => i.status_code === 'out_of_stock').length,
      expiredCount: items.filter(i => i.status_code === 'expired').length,
      utilizationRate: count ? Math.round((items.filter(i => i.status_code === 'active').length / count) * 100) : 0,
    };

    return { items, total: count || 0, stats };
  },

  async deleteAgroProductAsset(id: string, companyId: string): Promise<void> {
    const { error } = await supabase
      .from('agro_assets')
      .delete()
      .eq('id', id)
      .eq('company_id', companyId);

    if (error) throw error;
  },

  async getGroups(companyId: string) {
    const { data, error } = await supabase
      .from('agro_groups')
      .select('id, name, parent_id, level, path')
      .eq('company_id', companyId)
      .order('sort_order');
    if (error) throw error;
    return data || [];
  },
};

